import { render, staticRenderFns } from "./paid.vue?vue&type=template&id=ec65b2e6&"
import script from "./paid.vue?vue&type=script&lang=js&"
export * from "./paid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports